const AbstractCloverTransaction = require('@/lib/PaymentMethods/Clover/AbstractCloverTransaction');
const CloverPaymentAndRefundResult = require('@/lib/PaymentMethods/Clover/Enums/CloverPaymentAndRefundResult');
const CloverTransactionClassName = require('@/lib/PaymentMethods/Clover/Enums/CloverTransactionClassName');
const CloverTransactionEndState = require('@/lib/PaymentMethods/Clover/Enums/CloverTransactionEndState');
const { fromMinorUnit } = require('@/functions/math');

// This is a slimmed down version of CloverTransaction that is used to handle voiding an existing transaction.
// If the VOID is not possible Clover will automatically attempt a REFUND instead.
// Note: CloverTransaction can also perform VOIDs in the event of cancellations, rejection due to issues, etc.
class CloverVoidTransaction extends AbstractCloverTransaction {
    // eslint-disable-next-line no-useless-constructor
    constructor(amountInMinorUnits, callback) {
        super(CloverTransactionClassName.VOID);
        if (!amountInMinorUnits || !Number.isInteger(amountInMinorUnits)) {
            throw new Error('CloverVoidTransaction requires amountInMinorUnits to be an Integer');
        }

        if (!callback) {
            throw new Error('CloverVoidTransaction requires a callback');
        }

        /**
         * The total amount in minor units including tips.
         * This isn't required for the VOID this is just for the UI.
         *
         * @type {number}
         */
        this.amountInMinorUnits = amountInMinorUnits;

        this.originalAmountInMajorUnits = fromMinorUnit(amountInMinorUnits);

        /**
         * A callback to handle updates outside the CloverPaymentCtrl partial e.g. payment list in right column.
         *
         * @type {function}
         */
        this.voidResultHandler = callback;
    }

    addResponse(response) {
        this.latestResponse = response;

        if (!this.latestResponse) {
            throw new Error('Missing response');
        }

        // Update the userMessage if there is a new userMessage otherwise leave any existing userMessage.

        if (this.latestResponse.data && this.latestResponse.data.message) {
            this.userMessage = this.latestResponse.data.message;
        }

        // Check the response if it isn't 200 then update messages but don't continue.
        if (!this.isHttpResponseSuccess()) {
            return;
        }

        // The final state of the transaction.
        if (this.latestResponse.data) {
            if (this.latestResponse.data.payment) {
                switch (this.latestResponse.data.payment.result) {
                    case CloverPaymentAndRefundResult.VOIDED:
                        this.setTransactionVoided();
                        this.voidResultHandler(CloverTransactionEndState.VOID);
                        break;
                    case CloverPaymentAndRefundResult.VOID_FAILED:
                        this.setTransactionSuccessfulVoidFailed();
                        this.voidResultHandler(CloverTransactionEndState.VOID_FAILED);
                        break;
                }
            }
        }
    }
}

module.exports = CloverVoidTransaction;
